module.exports = __webpack_public_path__ + "img/crown_jhakaas.4cd60803.svg";